import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import logoDark from "../../assets/images/Go_Safe_Logo.png";
import logoLight from "../../assets/images/Go_Safe_Logo.png";
import logoIcon from "../../assets/images/Go_Safe_Logo.png";
import country1 from "../../assets/images/language/american.png";
import doctor1 from "../../assets/images/doctors/01.jpg";

import {
  FaBars,
  FiSettings,
  FiMail,
  GrDashboard,
  RiLogoutCircleRLine,
  BsPerson,
} from "../../assets/icons/vander";

import { countryData } from "../data";

import SimpleBar from "simplebar-react";
import Offcanvas from "react-bootstrap/Offcanvas";

import { useAuthStore } from "../../auth/hooks";

export const TopHeader = ({ toggle, setToggle }) => {
  const [countryModal, setCountryModal] = useState(false);
  const [mailModal, setMailModal] = useState(false);
  const [userModal, setUserModal] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setUserModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const { user, startLogout } = useAuthStore();

  return (
    <div className="top-header">
      <div className="header-bar d-flex justify-content-between border-bottom">
        <div className="d-flex align-items-center">
          <Link to="#" className="logo-icon">
            <img src={logoIcon} height="30" className="small" alt="" />
            <span className="big">
              <img
                src={logoDark}
                height="22"
                className="logo-light-mode"
                alt=""
              />
              <img
                src={logoLight}
                height="22"
                className="logo-dark-mode"
                alt=""
              />
            </span>
          </Link>
          <Link
            onClick={() => setToggle(!toggle)}
            className="btn btn-icon btn-pills btn-soft-primary ms-2"
            to="#"
          >
            <FaBars />
          </Link>
          <div className="search-bar p-0 d-none d-lg-block ms-2">
            <div id="search" className="menu-search mb-0"></div>
          </div>
        </div>

        <div className="dropdown dropdown-primary" ref={dropdownRef}>
          <button
            type="button"
            className="btn btn-pills btn-soft-primary dropdown-toggle p-0"
            onClick={() => setUserModal(!userModal)}
          >
            <BsPerson className="avatar avatar-ex-small rounded-circle p-1" />
          </button>
          <div
            className={`${
              userModal ? "show" : ""
            } dropdown-menu dd-menu dropdown-menu-end shadow border-0 py-3`}
            style={{ minWidth: "200px", position: "absolute", right: "0" }}
          >
            <Link
              className="dropdown-item d-flex align-items-center text-dark"
              to="#"
            >
              <div className="flex-1 ms-2">
                <span className="d-block mb-1">
                  {user.firstName} {user.lastName}
                </span>
                <small className="text-muted">{user.ipsName}</small>
              </div>
            </Link>
            <Link
              className="dropdown-item text-dark d-flex align-items-center"
              to="/secretary/dashboard"
            >
              <span className="mb-0 d-inline-flex me-1">
                <GrDashboard className="align-middle h6 mb-0" />
              </span>{" "}
              Dashboard
            </Link>
            <Link
              className="dropdown-item text-dark d-flex align-items-center"
              to="/secretary/profile"
            >
              <span className="mb-0 d-inline-block me-1">
                <FiSettings className="align-middle h6 mb-0" />
              </span>{" "}
              Configurar perfil
            </Link>
            <div className="dropdown-divider border-top"></div>
            <button
              className="dropdown-item text-dark d-flex align-items-center"
              onClick={() => {
                startLogout();
              }}
            >
              <span className="mb-0 d-inline-block me-1">
                <RiLogoutCircleRLine className="align-middle h6 mb-0" />
              </span>{" "}
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
